export const defaultColor="#1890ff";
export const primaryColor="#481A6C"
export const secondaryColor="#481A6C99"

export const treeMapOtherColor="#5F57D6"